export default "/kiban/_next/static/images/top_yellow-005ab6ff7533d12a026f366bba41f329.png";